/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:10:52
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsySelect from '../../BsySelect';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterFlowNode extends BsyFilterBase {


    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            method: BsyConfig().CONST.FILTER_METHOD.IN,
            ...props
        })
        this.state = {
            ...this.state,
            items: [],
        }

        this.dashText = null;
    }


    componentDidMount() {
        super.componentDidMount()
        this._loadFlowNode();

    }

    _loadFlowNode = () => {
        let that = this;
        React.axios("/dashboard/app/" + (that.options.appId || window.FX.STATIC.APPID) + "/workflow/query_node", {
            appId: that.options.appId || window.FX.STATIC.APPID,
            formId: that.options.formId || that.options.entryId || window.FX.STATIC.ENTRYID,
        }).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {

                var i = [];
                that.valueMap = {}
                BsyUtils.forEach(res.data.data, function (t, a) {
                    var n = [];
                    var v = [];
                    BsyUtils.forEach(a.value, function (e, t) {
                        n.push(t.flowId)
                        v.push(t.version)
                    })
                    i.push({
                        text: a._id,
                        value: v.join(',') + '|' + n.join(",")
                    })
                    that.valueMap[v.join(',') + '|' + n.join(",")] = a.value
                })
                this.setState({
                    items: [...i]
                })
            })

        }).catch(res => {
            console.error(res);
        })
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.IN]
    }

    getValue = () => {
        return this.dashText.getValue()
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue();
        let value = null
        if (val) {
            if (!BsyUtils.isObjectEmpty(val.value)) {
                if (Array.isArray(val.value)) {
                    value = val.value.join(",")
                } else {
                    value = val.value.toString()
                }
            } else {
                value = val
            }
        }
        return <BsySelect
            theme={this.props.theme}
            allowBlank={true}
            value={value}
            height={'34px'}
            onBeforeAsync={i.onBeforeAsync}
            items={this.state.items}
            onStopEdit={e1 => {
                e.value = e.getValue()

                BsyUtils.applyFunc(e, i.onStopEdit, [{
                    value: e.value,
                    valueMode: e.valueMode,
                    method: e.method,
                }, i], !1)
            }}
            getContext={this.getContext}
        />
    }

    render() {
        const { valueMode } = this.options;
        return (<>
            <div className={"bsy-dash-head " + valueMode}>
                <div className="bsy-cond-label" >
                    {this.options.title}
                </div>
                <div className='cond-method' style={{
                    lineHeight: '30px',
                    padding: '0 6px 0 10px'
                }}>{React.language("filter.method.in.flowNode")}</div>

            </div>
            <div className={'bsy-dash-cont '}>
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

